<a 
  href="javascript:void(0)"
  (click)="onTourClick($event)"
  class="text-info text-decoration-none"
  title="Ajuda"
  aria-label="Ajuda"
  style="cursor: pointer;">
  <i class="fas fa-question-circle me-1"></i>
  Ajuda
</a>

